import { httpClient } from "./httpClient";
import { authInterceptor } from "./auth.interceptor";
import { refreshInterceptor } from "./refresh.interceptor";
import { errorInterceptor } from "./error.interceptor";

httpClient.interceptors.request.use(authInterceptor);
httpClient.interceptors.response.use(
  (res) => res,
  refreshInterceptor
);
httpClient.interceptors.response.use(
  (res) => res,
  errorInterceptor
);

export default httpClient;
